<template>
    <div class="inside_pages_right">
        <NoticeTop></NoticeTop>
        <div class="inside_pages_right_content">
            <div class="inside_pages_content_two" v-show="listBox == true">
                <div class="content_top_three ">
                    <div class="inside_pages_right_content_top_left ">
                        <el-button  type="primary" plain size="mini" icon="el-icon-document-remove">
                            撤回
                        </el-button>
                        <el-button  type="primary" plain size="mini" icon="el-icon-circle-close">
                            删除
                        </el-button>
                    </div>
                </div>
                <div class="content_center_three">
                    <el-table :data="responseData.list"  height="100%" border style="width: 100%"  @selection-change="selectActionData">
                        <el-table-column type="selection" width="40"> </el-table-column>
                        <el-table-column prop="name1" label="标题">
                        </el-table-column>
                        <el-table-column prop="name2" label="接收人">
                        </el-table-column>

                        <el-table-column prop="name3" label="已阅/总人数">
                        </el-table-column>

                        <el-table-column prop="date1" label="发送时间">
                            <template slot-scope="rowData">
                                {{$Common.dateFormatDate(rowData.row.date1)}}
                            </template>
                        </el-table-column>

                        <el-table-column  label="操作" width="340">
                            <template slot-scope="scope">
                                <el-button  type="primary" plain size="mini">
                                    查看详情
                                </el-button>
                                <el-button  type="primary" plain size="mini">
                                    撤回
                                </el-button>
                                <el-button  type="primary" plain size="mini"   icon="el-icon-circle-close" >
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="content_bottom_three">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="responseData.pageNum"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="responseData.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NoticeTop from '@/components/NoticeTop'
export default {
    name:'',
    components: {NoticeTop},
    props: {},
    data() {
        return {

            listBox:true,
            editBox:false,
            requestData:{
                schoolId:this.$store.state.schoolId,
                pageSize:20,
                pageNum:1,
                type:'',
            },
            responseData:{
                pageSize:20,
                pageNum:1,
                total:0,
                pages:0,
                list:[
                    {
                        id:99999,
                        name1:'这是一个测试',
                        name2:'111,超级管理员,超级管理员',
                        name3:'1/2',
                        date1:1593273599,
                    },
                    {
                        id:99999,
                        name1:'这是一个测试',
                        name2:'111,超级管理员,超级管理员',
                        name3:'1/2',
                        date1:1593273599,
                    },
                    {
                        id:99999,
                        name1:'这是一个测试',
                        name2:'111,超级管理员,超级管理员',
                        name3:'1/2',
                        date1:1593273599,
                    },

                  
                   
                ],
            },
            selectedDataList:[],

        };
    },
    watch: {},
    computed: {},
    methods: {
        selectActionData(selectData){
            this.selectedDataList = []
            selectData.forEach(element => {
                this.selectedDataList.push(element.id)
            });

            // console.log(this.selectedDataList)
        },
        openEditBox(){
            this.listBox = false
            this.editBox = true
        },
        
        closeEditBox(){
            this.listBox = true
            this.editBox = false
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }

      
    },
    created() {},
    mounted() {
    }
};
</script>
<style scoped>
</style>